import React, {useState, useEffect} from "react";
import { ReactComponent as WarningTriangleIcon } from 'assets/icons/warning-triangle.svg';
import { ReactComponent as WarningIcon } from 'assets/icons/warning.svg';
import s from "./error-block.module.scss";

const ErrorBlock = (props) => {
    
    const [errorMessage, setErrorMessage] = useState(props.errorMessage ? props.errorMessage.message : "ERROR");
    const [styles, setStyles] = useState(props.styles ? props.styles : null);

    useEffect(() => {
        setErrorMessage(props.errorMessage ? props.errorMessage.message : "ERROR");
        setStyles(props.styles ? props.styles : null)
    }, [props.errorMessage, props.styles])

    return (
        <div className={s.ErrorBlock} style={{...styles}}>
            <div className={s.MessageBlock}>
                <span>{errorMessage}</span>
            </div>
            <WarningIcon />
        </div>
    )
}

export default ErrorBlock;